import React, { Component, PropTypes } from 'react';
import { StudentOverviewStore } from 'stores';
import { StudentOverviewActions } from 'actions';
import AppPage from 'components/AppPage';
import RulerBar from 'components/RulerBar';
import ListDetail from 'components/Material/ListDetail';
import { mixin, RefluxMixin } from 'Util';
import {
  FloatingActionButton,
  Styles,
  ListItem,
  RaisedButton
} from 'material-ui';
import { TagSelector, TagList } from 'components/Tags';
import * as Colors from 'components/Material/Styles/Colors';
import * as SvgIcons from 'components/Material/SvgIcons';
import Css from 'Css';

const { Units } = Css;

const css = oxygenCss({
  filterContainer: {
    padding: Units.base,
    textAlign: 'center'
  },
  buttonWrapper: {
    margin: Units.base / 2,
    display: 'inline-block'
  }
});

export default class Students extends mixin(RefluxMixin, Component) {
  // mixins : [AuthMixin, IntlMixin, Reflux.connect(AppStore, 'app'), Reflux.connect(AuthStore, 'auth'), Reflux.connect(StudentStore, 'students')],

  state = {
    filter: {}
  };

  static defaultProps = {
    filterBar: true
  };

  static contextTypes = {
    muiTheme: PropTypes.object,
    getIntlMessage: PropTypes.func
  };

  listenToStores() {
    this.listenToStoreWithMapper(StudentOverviewStore, state => {
      return {
        user: state.user,
        invitation: state.invitation,
        activeList: state.activeList
      };
    });
  }

  componentDidMount() {
    const { activeList } = this.state;
    StudentOverviewActions.getList(activeList);
  }

  gotoStudent(student) {
    if (student.realUser) {
      this.props.router.push(`/student/${student.id}`);
      // StudentActions.findById(student);
    } else {
      this.props.router.push(`/invitation-detail/${student.id}`);
      // InvitationActions.showInfo(student);
    }
  }

  getItemStyle() {
    let style = {};
    return style;
  }

  createListItem(item, leftAvatar, insetChildren) {
    let style = this.getItemStyle();
    if (this.state.selected && item.id === this.state.selected.id) {
      style.backgroundColor = Colors.Colors.grey[300].material;
    }

    return (
      <ListItem
        style={style}
        leftAvatar={leftAvatar}
        insetChildren={insetChildren}
        key={'i' + item.id}
        primaryText={item.name}
        secondaryText={<TagList dense tags={item.tagsMap} />}
        onTouchTap={this.gotoStudent.bind(this, item)}
      />
    );
  }

  deleteTag = tagName => {
    const filter = {
      ...this.statefilter
    };
    delete filter[tagName];
    this.setState({ filter });
  };

  addTag = tagName => {
    this.setState({
      filter: {
        ...this.state.filter,
        [tagName]: true
      }
    });
  };

  export() {
    this.props.router.push('/student/export');
  }

  setTab = list => {
    StudentOverviewActions.changeList(list);
  };

  renderFilterBar() {
    const { activeList } = this.state;
    return (
      <div className={css.filterContainer}>
        <div className={css.buttonWrapper}>
          <RaisedButton
            label={this.context.getIntlMessage('students.students')}
            backgroundColor="#ddd"
            onTouchTap={this.setTab.bind(this, 'user')}
            disabled={activeList === 'user'}
            disabledBackgroundColor="#00c9cc"
            disabledLabelColor="#ffffff"
          />
        </div>
        <div className={css.buttonWrapper}>
          <RaisedButton
            label={this.context.getIntlMessage('students.invitations')}
            backgroundColor="#ddd"
            onTouchTap={this.setTab.bind(this, 'invitation')}
            disabled={activeList === 'invitation'}
            disabledBackgroundColor="#00c9cc"
            disabledLabelColor="#ffffff"
          />
        </div>
      </div>
    );
  }

  render() {
    const { activeList } = this.state;
    const items = this.state[activeList].list;
    const loading = this.state[activeList].loading;

    let exportForm;
    let filterFunc = (item, searchText, labelProperty, emailProperty) => {
      let hasTags = true;
      Object.keys(this.state.filter).forEach(tagName => {
        let tagsMap = item.tagsMap || {};
        hasTags = hasTags && tagsMap[tagName];
      });
      if (!hasTags) {
        return false;
      }
      if (searchText && searchText !== '') {
        return (
          item[labelProperty].search(searchText) > -1 ||
          item[emailProperty].search(searchText) > -1
        );
      } else {
        return true;
      }
    };

    const tagSelector = (
      <div>
        {this.renderFilterBar()}
      </div>
    );

    return (
      <AppPage header={<RulerBar title="Students" />} className={'student'}>
        <ListDetail
          key={activeList}
          activeList={this.state.user && this.state.user.list}
          loading={loading}
          filter={filterFunc}
          listHeader={tagSelector}
          items={items}
          listItemGenerator={this.createListItem.bind(this)}
          floatingActionButton={
            <FloatingActionButton onTouchTap={this.export.bind(this)}>
              <SvgIcons.ActionLaunch />
            </FloatingActionButton>
          }
        >
          {this.props.children}
        </ListDetail>
      </AppPage>
    );
  }
}



// WEBPACK FOOTER //
// ./src/js/components/Route/Students.js